import {
  ActionReducerMapBuilder,
  createAsyncThunk,
  PayloadAction,
} from "@reduxjs/toolkit";
import {
  RouteModel,
  RouteModelInput,
} from "../../../../domain/models/routeModel";
import RouteService from "../../../service/routeService";
import { GraphQLClient } from "../../../../../../../shared/gql-client";
import { PlanningSliceModel } from "../../PlanningSlice";

const routeApi = new RouteService();

export const createPlanningRoute = createAsyncThunk(
  "planning/create/new/route",
  async (route: RouteModelInput, thunkAPI) => {
    const { client } = thunkAPI.extra as { client: GraphQLClient };
    try {
      const { planning } = thunkAPI.getState() as {
        planning: PlanningSliceModel;
      };
      routeApi.setClient(client);
      return await routeApi.createRoute({
        ...route,
        date: planning.date,
        delta: RouteService.getRouteDelta(planning.routes),
      });
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  },
);

export const extraReducersCreatePlanningRoute = (
  builder: ActionReducerMapBuilder<PlanningSliceModel>,
) => {
  builder.addCase(createPlanningRoute.pending, (state) => {
    state.loading = true;
  });
  builder.addCase(
    createPlanningRoute.fulfilled,
    (state, action: PayloadAction<unknown>) => {
      const newRouteModel = action.payload as RouteModel;
      state.routes = [...state.routes, newRouteModel];
    },
  );
};
